import React from 'react';
import { makeStyles } from '@mui/styles';
import { Card, CardContent, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import palette from '../theme/palette';

const useStyles = makeStyles({
  titleText: {
    textTransform: 'uppercase',
    fontSize: 12,
    color: palette.grey[500]
  },
  subText: {
    fontSize: 19
  }
});

export default function TestInfoCard({
  createdOn,
  startTime,
  endTime,
  duration,
  questions,
  marks,
  submissionDate
}) {
  const classes = useStyles();
  return (
    <Card style={{ marginTop: 15 }}>
      <CardContent>
        <Grid container columnSpacing={2} rowSpacing={2}>
          {createdOn && (
            <Grid item md={4} sm={6} xs={12}>
              <p className={classes.titleText}>CREATED ON</p>
              <p className={classes.subText}>{createdOn}</p>
            </Grid>
          )}
          {startTime && (
            <Grid item md={4} sm={6} xs={12}>
              <p className={classes.titleText}>START TIME</p>
              <p className={classes.subText}>{startTime}</p>
            </Grid>
          )}
          {submissionDate && (
            <Grid item md={4} sm={6} xs={12}>
              <p className={classes.titleText}>SUBMISSION DATE</p>
              <p className={classes.subText}>{submissionDate}</p>
            </Grid>
          )}
          {endTime && (
            <Grid item md={4} sm={6} xs={12}>
              <p className={classes.titleText}>END TIME</p>
              <p className={classes.subText}>{endTime}</p>
            </Grid>
          )}
          {duration && (
            <Grid item md={4} sm={6} xs={12}>
              <p className={classes.titleText}>DURATION</p>
              <p className={classes.subText}>{duration}</p>
            </Grid>
          )}
          {questions && (
            <Grid item md={4} sm={6} xs={12}>
              <p className={classes.titleText}>NO. OF QUESTIONS</p>
              <p className={classes.subText}>{questions}</p>
            </Grid>
          )}
          {marks && (
            <Grid item md={4} sm={6} xs={12}>
              <p className={classes.titleText}>MARKS</p>
              <p className={classes.subText}>{marks}</p>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}

TestInfoCard.propTypes = {
  createdOn: PropTypes.string,
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  duration: PropTypes.string,
  questions: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  marks: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  submissionDate: PropTypes.string
};
